<template>
	<div class="page-content header-clear-medium">
		<div class="card card-style">
			<div class="content">
				<h3 class="mb-3">Monitoring Presensi Guru</h3>

				<div class="row mb-3">
					<div class="col-lg-5">
						<div class="form-custom form-label form-border form-icon mb-2">
							<i class="bi bi-calendar font-12"></i>
							<input type="date" class="form-control rounded-xs" id="c5" v-model="presenceDate">
						</div>
					</div>
					<div class="col-lg-5">
						<div class="form-custom form-label form-border form-icon mb-0">
							<i class="bi bi-list-ol font-13"></i>
							<select v-model="presenceStatus" class="form-select rounded-xs" id="c7" aria-label="Floating label select example">
								<option value="" selected="">- Pilih Status -</option>
								<option value="all">Semua</option>
								<option value="H">Hadir</option>
								<option value="A">Tidak Hadir</option>
							</select>
							<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
						</div>
					</div>
					<div class="col-lg-2">
						<button class="btn w-100 btn-sm bg-green-light" @click="getDetailPresenceByDate()">Cari</button>
					</div>
				</div>

				<div class="row mb-3" v-if="!loading">
					<div class="col-lg-2">
						<button class="btn w-100 btn-xs bg-red-light" @click="generateReport()">Export PDF</button>
					</div>
				</div>
				
				<vue-html2pdf
					v-if="!loading"
					:show-layout="false"
					:float-layout="true"
					:enable-download="true"
					:preview-modal="true"
					:paginate-elements-by-height="1400"
					:filename="`Laporan Presensi Guru Tanggal ${presenceDate}`"
					:pdf-quality="2"
					:manual-pagination="false"
					pdf-format="a4"
					pdf-orientation="landscape"
					pdf-content-width="100%"
			
					@progress="onProgress($event)"
					@hasStartedGeneration="hasStartedGeneration()"
					@hasGenerated="hasGenerated($event)"
					ref="html2Pdf"
				>
					<section slot="pdf-content">
						<div class="row">
							<div class="col-lg-12">
								<p class="mb-2"><strong>{{ total_teachers_presence }}</strong> dari <strong>{{ total_teachers }}</strong> Guru Telah Melakukan Presensi Pada Tanggal {{ presenceDate }}</p>
								<h5>Detail :</h5>
		
								<div class="table-responsive">
									<table class="table color-theme mb-2">
										<thead>
											<tr>
												<th class="border-fade-gray" scope="col">Nama</th>
												<th class="border-fade-gray text-center" scope="col">Masuk</th>
												<th class="border-fade-gray text-center" scope="col">Pulang</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="item in presences_teacher" :key="item.nik_log" class="border-fade-gray">
												<td class="font-14">{{ item.nama }}</td>
												<td class="text-center"><span class="badge bg-secondary font-11" :style="{ backgroundColor: item.check_in.status_masuk + ' !important' }">{{ item.check_in.jam_masuk }}</span></td>
												<td class="text-center"><span class="badge bg-secondary font-11" :style="{ backgroundColor: item.check_out.status_pulang + ' !important' }">{{ item.check_out.jam_pulang }}</span></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</section>
				</vue-html2pdf>
				
				<p class="mb-2" v-if="!loading"><strong>{{ total_teachers_presence }}</strong> dari <strong>{{ total_teachers }}</strong> Guru Telah Melakukan Presensi Pada Tanggal {{ presenceDate }}</p>
				<p class="mb-2" v-else><strong>Loading...</strong></p>

				<div class="d-flex flex-column">
					<h5>Detail :</h5>

					<div v-if="!loading" class="table-responsive">
						<table class="table color-theme mb-2">
							<thead>
								<tr>
									<th class="border-fade-gray" scope="col">Nama</th>
									<th class="border-fade-gray text-center" scope="col">Masuk</th>
									<th class="border-fade-gray text-center" scope="col">Pulang</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in presences_teacher" :key="item.nik_log" class="border-fade-gray">
									<td class="font-14">{{ item.nama }}</td>
									<td class="text-center"><span class="badge bg-secondary font-11" :style="{ backgroundColor: item.check_in.status_masuk + ' !important' }">{{ item.check_in.jam_masuk }}</span></td>
									<td class="text-center"><span class="badge bg-secondary font-11" :style="{ backgroundColor: item.check_out.status_pulang + ' !important' }">{{ item.check_out.jam_pulang }}</span></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-else>
						<vue-skeleton-loader
							v-for="i in 5"
							:key="i"
							:height="20"
							animation="fade" 
							class="w-100 rounded-s mt-2"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	mapActions, mapState, mapMutations
} from 'vuex'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'

export default {
	name: 'Presence',
	components: {
		VueHtml2pdf
	},
	data() {
		return {
			presenceDate: moment().format('YYYY-MM-DD'),
			presenceStatus: 'all',
			activeColor: '#fefefe'
		}
	},
	async created() {
		this.getDetailPresenceByDate()
	},
	methods: {
		...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
		...mapActions('presenceTeacher', ['getPresencesTeacher']),
		async getDetailPresenceByDate() {
			this.SET_LOADING()

			await this.getPresencesTeacher({date: this.presenceDate, status: this.presenceStatus})

			this.CLEAR_LOADING()
		},
		generateReport () {
            this.$refs.html2Pdf.generatePdf()
        }
	},
	computed: {
		...mapState({
			loading: state => state.loading
		}),
		...mapState('presenceTeacher', {
			presences_teacher: state => state.presences_teacher,
			total_teachers: state => state.total_teachers,
			total_teachers_presence: state => state.total_teachers_presence,
		}),
	}
}
</script>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}
</style>
